import BasicResource from '@/api/resource';

class ApplicationsResource extends BasicResource {
    constructor () {
        super('applications');
    }

    events (applicationId, params = {}) {
        return this.client.request ({
            method: 'get',
            path: `/upyield/v1/${this.resourceName}/${applicationId}/events`,
            params,
        });
    }

    event (applicationId, eventId, params) {
        return this.client.request ({
            method: 'get',
            path: `/upyield/v1/${this.resourceName}/${applicationId}/events/${eventId}`,
            params,
        });
    }

    createEvent (applicationId, payload) {
        return this.client.request ({
            method: 'post',
            path: `/upyield/v1/${this.resourceName}/${applicationId}/events`,
            data: payload,
        });
    }

    updateEvent (applicationId, eventId, payload) {
        return this.client.request ({
            method: 'put',
            path: `/upyield/v1/${this.resourceName}/${applicationId}/events/${eventId}`,
            data: payload,
        });
    }

    deleteEvent (applicationId, eventId) {
        return this.client.request ({
            method: 'delete',
            path: `/upyield/v1/${this.resourceName}/${applicationId}/events/${eventId}`,
        });
    }

    availableCampaignIds (applicationId, params) {
        return this.client.request ({
            method: 'get',
            path: `/upyield/v1/${this.resourceName}/${applicationId}/campaigns/available`,
            params,
        });
    }

    usedCampaignIds (applicationId, params) {
        return this.client.request ({
            method: 'get',
            path: `/upyield/v1/${this.resourceName}/${applicationId}/campaigns/used`,
            params,
        });
    }
}

export default new ApplicationsResource;
